import { useCallback } from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { getLastPurchaseChallanDaybook } from '../redux/actions/PurchaseChallan';
import moment from 'moment';

const usePurchaseChallanLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastPurchaseDaybook = useSelector((state) => state.purchaseChallan?.lastPurchaseDaybook);

   const getLastDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         const fromDate = localStorage.getItem('selectedFy_start_date');
         const toDate = localStorage.getItem('selectedFy_end_date');

         const params = {
            companyId: user.loginhistory.companyId,
            fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastPurchaseChallanDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastDaybook();
   }, [getLastDaybook]);

   return {
      lastPurchaseDaybook,
      setSelectedDaybookId,
   };
};

export default usePurchaseChallanLastDaybook;
